import React from "react";
import { node, string, bool, PropTypes } from "prop-types";
import classNames from "classnames";
import { Field } from "react-final-form";

import css from "../FieldCheckbox/FieldCheckbox.module.css";
import Toggle from "./component/Toggle";

const NotificationToggle = (props) => {
  const {
    rootClassName,
    className,
    svgClassName,
    textClassName,
    id,
    label,
    useSuccessColor,
    disabled,
    name,
    checked,
    ...rest
  } = props;

  const [toggleChecked, setToggleChecked] = React.useState(checked);

  const handleToggle = (input, event) => {
    const { onChange } = input;
    const newChecked = event.target.checked ? "active" : "inactive";
    onChange(newChecked);
    setToggleChecked(newChecked);
  };

  return (
    <Field
      type="checkbox"
      name={name}
      {...rest}
      value={toggleChecked === "active" ? "active" : "inactive"}
      defaultValue={toggleChecked === "active" ? "active" : "inactive"}
    >
      {(props) => {
        const { input, disabled } = props;

        return (
          <>
            <input
              id={id}
              className={css.input}
              {...input}
              onChange={(event) => handleToggle(input, event)}
              disabled={disabled}
              checked={input.value === "active"}
              value={input.value}
            />
            <label htmlFor={id} className={css.label}>
              <span className={css.checkboxWrapper}>
                <Toggle
                  className={svgClassName}
                  active={toggleChecked === "active"}
                />
              </span>
              <span
                className={classNames(css.text, textClassName || css.textRoot)}
              >
                {label}
              </span>
            </label>
          </>
        );
      }}
    </Field>
  );
};

// TODO: REFEACTOR PROPS
NotificationToggle.defaultProps = {
  className: null,
  rootClassName: null,
  svgClassName: null,
  textClassName: null,
  label: null,
  checked: "inactive",
};

NotificationToggle.propTypes = {
  className: string,
  rootClassName: string,
  svgClassName: string,
  textClassName: string,
  disabled: bool,
  checked: PropTypes.oneOf(["active", "inactive"]),

  // Id is needed to connect the label with input.
  id: string.isRequired,
  label: node,

  // Name groups several checkboxes to an array of selected values
  name: string.isRequired,
};

export default NotificationToggle;
